<ng-template #confirmModal let-modal>
    <app-button-modal-close [modalSize]="'sm'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ modalService.confirmModal.modalHeader }}</h2>
        <p *ngIf="modalService.confirmModal.modalBody"
           [innerHTML]="modalService.confirmModal.modalBody"
           style="margin: 10px 0">
        </p>
        <div class="btn-group btn-block w-100">
            <button (click)="modal.close(true)"
                    *ngIf="modalService.confirmModal.buttonSubmit" class="btn btn-primary">
                <span>{{ modalService.confirmModal.buttonSubmit }}</span>
            </button>
            <button (click)="modal.dismiss(false)"
                    *ngIf="modalService.confirmModal.buttonClose"
                    class="btn btn-danger close_modal">
                <span>{{ modalService.confirmModal.buttonClose }}</span>
            </button>
        </div>
    </div>
</ng-template>
